export default {
  supplier: {
    dashboard: {
      title: 'Tablero',
      description: 'En esta sección podrá encontrar información sobre su catálogo y actividad',
    },
    catalog: {
      title: 'Catalogo',
      description: 'En esta sección podrá realizar búsquedas específicas sobre su catálogo de ítems',
    },
    'request-information': {
      title: 'Solicitudes de Información',
      description: 'En esta sección podrá reponder a consultas sobre tus ítems',
    },
    report: {
      title: 'Actividad de mi catálogo',
      description: 'En esta sección podrá conocer información sobre tus ítems',
    },
    newDashboard: {
      title: 'Dashboard',
      description: 'En esta sección podrá ver estadísticas sobre su empresa o unilink',
    },
    'supplier-admin': {
      title: 'Administración',
    },
    products: {
      title: 'Items',
      description: 'En esta sección podrá editar o eliminar sus Items',
    },
    users: {
      title: 'Usuarios',
      description: 'En esta sección podrá editar, activar o bloquear a sus usuarios',
    },
    search: {
      title: 'Ver mi Catálogo',
      description: 'En esta sección podrá ver tu catálogo',
    },
    admin: {
      title: 'Administrar mi catálogo',
      description: 'En esta sección podrá crear, editar y eliminar items de su catalogo',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/routes/supplier.js